<template>
  <div id="modal-header" class="row no-gutters">
    <div class="col">
      <p class="modal-title" :style="titleStyle" :lang="narratorLang" tabindex="-1" :aria-label="$t(titleText)">
        {{$t(titleText)}}
      </p>
    </div>

    <div class="col-12 pt-4" v-if="hasSeparator">
      <hr class="line" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModalHeader',
  props: {
    titleText: {
      type: String,
      required: true
    },
    titleStyle: {
      type: [Object, Array],
      required: false,
      default: () => ({
        fontFamily: 'Roboto',
        fontSize: '20px',
        fontWeight: 'bold',
        color: 'var(--darkerGrey2)'
      })
    },
    hasSeparator: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      narratorLang: 'settings/getNarratorLanguage'
    })
  }
};
</script>

<style lang="scss" scoped>
#modal-header {
  .line {
    height: 1px;
    background-color: var(--lightGrey);
    box-sizing: border-box;
    margin: 0;
    border-style: initial;
  }
  .modal-title {
    margin: 36px 18px 16px 18px;
    font-family: Roboto;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    color: var(--terraGrey);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/elements/modal/ModalHeader.vue